//@flow
import React from 'react';

type LeftNavContextType = {
  isExpanded: boolean,
  setIsExpanded: (boolean) => void,
};

export const LeftNavContext: React$Context<LeftNavContextType> = React.createContext({
  isExpanded: false,
  setIsExpanded: () => {},
});

export const LeftNavProvider = ({ children }: {children: React$Node}): React$Node => {
  const [isExpanded, setIsExpanded] = React.useState(false);
  
  const value = {
    isExpanded,
    setIsExpanded,
  };
  
  return (
    <LeftNavContext.Provider value={value}>
      {children}
    </LeftNavContext.Provider>
  );
};

export const useLeftNav = (): LeftNavContextType => {
  const context = React.useContext(LeftNavContext);
  if (context === undefined) {
    throw new Error('useLeftNav must be used within a LeftNavProvider');
  }
  return context;
};
